module.exports = __webpack_public_path__ + "static/media/moons_escaneo_3D.9f820690.webp";